import TextComponent from "../../../../components/TextComponent/TextComponent";
import styles from "./OtherPaymentComponent.module.scss";

interface OtherPaymentComponentProps {
  text: string;
  price: string;
}

function OtherPaymentComponent(props: OtherPaymentComponentProps) {
  const { text, price } = props;
  return (
    <div className={styles.otherPaymentComponentContainer}>
      <div className={styles.otherPaymentTextAndIconWrapper}>
        <i className={`las la-user-circle icon-medium`} />
        <TextComponent
          text={text}
          fontSize="body-medium"
          color="primary"
          underline
          noPadding
          lightFont
        />
      </div>
      <div className={`body-medium ${styles.otherPaymentPrice}`}>{price}</div>
    </div>
  );
}

export default OtherPaymentComponent;
